<div class="flex-row field-input">
  <div [ngStyle]="labelStyle != null ? labelStyle : {}">
    {{ booleanLabel }}
  </div>
  <mat-form-field appearance="outline">
    <mat-select
      matInput
      placeholder="Maak een keuze"
      [(ngModel)]="_value.value"
      (ngModelChange)="onBooleanValueChanged()"
      required
    >
      <mat-option [value]="true">Ja</mat-option>
      <mat-option [value]="false">Nee</mat-option>
    </mat-select>
  </mat-form-field>
</div>
<div
  *ngIf="_value && _value.value === true"
  class="flex-row field-input"
  [ngStyle]="inputFieldStyle != null ? inputFieldStyle : {}"
>
  <div [ngStyle]="labelStyle != null ? labelStyle : {}">
    {{ priceLabel }}
  </div>
  <mat-form-field appearance="outline">
    <mat-icon matPrefix>euro_symbol</mat-icon>
    <input class="text-right" matInput mask="0*" [(ngModel)]="_value.price" />
  </mat-form-field>
</div>
